import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

export const useMyReservations = (options?: SWRConfiguration) => {
  const client = useGyymClient()
  return useGyymSWR([client.user.reservations.me], options)
}
